export default __webpack_public_path__ + "static/media/Metatavu-icon-black.69b624cc.svg";